import './../MemberStat.css';
import React, {Component} from 'react';
import MemberTraitLine from './MemberTraitLine';
class MemberTrait extends Component{
    render() {
        if(this.props.traits != null && this.props.traits !== [] ){ 
            let traitsSlice = this.props.traits.slice(0, 10);
            return(
                <div className='flex flex-col justify-between'>
                {traitsSlice.map((trait,index) => (
                        <MemberTraitLine trait={trait} key={index} index={index}/>
                    ))}  
                </div>
            )
        } else {
			return (
				<div className="flex justify-center justify-items-stretch">
					<div className="w-16 h-16 border-b-2 border-white-900 rounded-full animate-spin"></div>
				</div>
			)
		}
        
    }
}
export default MemberTrait